/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'

const languages = [
  {
    lang: 'tr',
    name: 'Türkçe',
    flag: toAbsoluteUrl('/media/flags/turkey.svg'),
    isActive: true,
  },
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    isActive: false,
  },
  {
    lang: 'de',
    name: 'German',
    flag: toAbsoluteUrl('/media/flags/germany.svg'),
    isActive: false,
  },
]

const Languages: FC = () => {
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
          Uygulama Dili
          <span className='fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
            Türkçe
            <img
              className='w-15px h-15px rounded-1 ms-2'
              src={toAbsoluteUrl('/media/flags/turkey.svg')}
              alt='uygulama dili'
            />
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        {languages.map((l) => (
          <div
            className={`menu-item px-3`}
            key={l.lang}
            onClick={() => {
              if (!l.isActive) return
              setLanguage(l.lang)
            }}
          >
            <span
              className={clsx('menu-link d-flex px-5', {
                active: l.lang === currentLanguage?.lang,
                opacityHave: !l.isActive,
              })}
            >
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt='fleksup' />
              </span>
              {l.name} {l.isActive ? '' : <span className='de-active-lang-title'>(Yakında)</span>}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
